import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

// "From Partial Sale: <listing>" on a Meeting Room invite that came from a
// Partial Sale conversation (DealInterestType.partial_sale_listing). Renders
// nothing when the invite came any other way, or when the server withholds the
// link from this viewer. Links to the listing on My Partial Sales, which scrolls
// to and highlights it (partialSalesDeepLink.js).
// See docs/plans/2026-11-02-feat-partial-sale-meeting-room-button-and-nudge-plan.md
const PartialSaleSourceLine = ({ partialSaleListing, className }) => {
  const intl = useIntl();
  if (!partialSaleListing?.id || !partialSaleListing?.label) return null;

  const text = intl.formatMessage(
    { id: 'succession_deals.partial_sale_source.from' },
    { label: partialSaleListing.label }
  );
  const closed = partialSaleListing.closed
    ? ` ${intl.formatMessage({ id: 'succession_deals.partial_sale_source.closed' })}`
    : '';

  return (
    <p className={`text-sm text-succession-text-secondary ${className}`} data-partial-sale-source={partialSaleListing.id}>
      <a
        href={`/succession/my_partial_sales?listing_id=${encodeURIComponent(partialSaleListing.id)}`}
        className="text-succession-primary hover:underline"
      >
        {text}
      </a>
      {closed}
    </p>
  );
};

PartialSaleSourceLine.propTypes = {
  partialSaleListing: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    label: PropTypes.string,
    closed: PropTypes.bool,
  }),
  className: PropTypes.string,
};

PartialSaleSourceLine.defaultProps = {
  partialSaleListing: null,
  className: '',
};

export default PartialSaleSourceLine;
